export default {"footerNavContainer":"VXDvW","footerNavWrapper":"okiaI","footerNavGroups":"-y2zD"};